<template>
  <div 
    class="dropdown-custom"
    :class="[
      visible && 'dropdown-custom--active',
      className
    ]"
    ref="dropdown-custom"
    v-click-outside="{
      exclude: ['dropdown-custom'],
      handler: 'hide'
    }"
  >
    <div class="dropdown-custom__title" @click="open()">
      <slot name="dropdown-custom-title"></slot>
    </div>
    <ul class="dropdown-custom__menu">
      <slot name="dropdown-custom-menu"></slot>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    className: String,
  },
  data() {
    return {
      visible: false,
    }
  },
  methods: {
    hide() {
      this.visible = false;
    },
    open() {
      this.visible = !this.visible;
    },
    hideOnEsc() {
      document.addEventListener("keydown", (e) => {
        if (e.keyCode == 27) this.hide();
      });
    },
  },
  mounted() {
    this.hideOnEsc();
  },
};
</script>

<style lang="scss" scoped>
</style>
